module.exports = __webpack_public_path__ + "../resources/images/SkyCode_76-0c7a63fa6614abcc1153ea6d00104fd1.svg";